import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

export const FooterBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  max-width: 1520px;

  padding: 12px 16px;
  margin-bottom: 34px;
  margin-inline: auto;

  border-radius: 8px;

  background-color: var(--player-bg-main);

  z-index: 1;

  @media ${breakpoints.md} {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 32px;

    padding: 16px;
  }

  @media ${breakpoints.xs} {
    margin-bottom: 69px;
  }
`;

export const FooterPrivacyLink = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    transform: rotate(-90deg);

    path {
      stroke: var(--white-secondary);
    }
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const FooterInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
`;
